import { render } from "./TaskViewDetalleGuardado.vue?vue&type=template&id=627dc044"
import script from "./TaskViewDetalleGuardado.vue?vue&type=script&lang=js"
export * from "./TaskViewDetalleGuardado.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__